import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade, Setting, } from '@app-state';
import { CustomCron } from '@components/ui-cron/cron.models';
import { ClientErrorCodes, FeatureFlag, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MapperService, ProcessService, QueueDefinitionService, SettingService, } from '@services';
import { CalendarService } from '@services/calendar.service';
import { ODataService } from '@services/generics/odata.service';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { forkJoin, of, } from 'rxjs';
import { map, switchMap, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../../app-state/app-state.facade";
import * as i3 from "../../../services/setting.service";
import * as i4 from "../../../services/process.service";
import * as i5 from "../../../services/queue/queueDefinition.service";
import * as i6 from "../../../services/calendar.service";
import * as i7 from "@uipath/angular/components/ui-snackbar";
import * as i8 from "@angular/common/http";
var TriggerUpsertPageService = /** @class */ (function (_super) {
    tslib_1.__extends(TriggerUpsertPageService, _super);
    function TriggerUpsertPageService(_translateService, _appState, _settingService, _processService, _queueService, _calendarService, _snack, http) {
        var _this = _super.call(this, http, MapperService.triggerUpsertMap) || this;
        _this._translateService = _translateService;
        _this._appState = _appState;
        _this._settingService = _settingService;
        _this._processService = _processService;
        _this._queueService = _queueService;
        _this._calendarService = _calendarService;
        _this._snack = _snack;
        _this._endpoint = '/odata/ProcessSchedules';
        _this.processesSuggest$ = function (searchTerm, fetchSize, skipCount) {
            return _this._appState.user.folder
                .value$
                .pipe(switchMap(function () { return _this._processService
                .suggest(searchTerm, fetchSize, skipCount); }));
        };
        _this.getTimezones = function () {
            return _this._settingService
                .getTimezones()
                .pipe(map(function (timezones) {
                return timezones.map(function (tz) { return ({
                    id: tz.Value,
                    text: tz.Name,
                }); });
            }));
        };
        _this.getInstanceData = function (id, timezones) {
            return _super.prototype.getInstance.call(_this, id)
                .pipe(map(function (trigger) {
                var timezone = timezones
                    .find(function (t) { return t.id === trigger.timezone[0].id; });
                return tslib_1.__assign({}, trigger, { timezone: [timezone] });
            }), switchMap(function (trigger) {
                // process details and executorRobots are not returned on trigger endpoint
                return forkJoin({
                    process: _this.getProcess(trigger.process[0].id),
                    // if startStrategy is specific robots
                    robots: trigger.startStrategy === 0 ?
                        _this._getExecutorRobots(id) :
                        of([]),
                })
                    .pipe(map(function (_a) {
                    var process = _a.process, robots = _a.robots;
                    trigger.process[0].data = process;
                    trigger.executorRobots = robots;
                    return trigger;
                }));
            }));
        };
        _this.getProcess = function (id) {
            return _this._processService
                .getInstance(id);
        };
        _this.getQueueDefinition = function (id) {
            return _this._queueService
                .getInstance(id);
        };
        _this.getDefaultCalendar = function () {
            return _this._settingService
                .getCalendar();
        };
        _this.getCalendarNames = function () {
            return _this._calendarService
                .get()
                .pipe(map(function (calendars) { return calendars.data.map(function (calendar) { return ({
                id: calendar.calendarId,
                text: calendar.calendarName,
            }); }); }));
        };
        return _this;
    }
    Object.defineProperty(TriggerUpsertPageService.prototype, "timezoneId", {
        get: function () {
            return this._appState.settings.get(Setting.timezoneId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageService.prototype, "isMultipleCalendarsEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.MultipleNonWorkingCalendars);
        },
        enumerable: true,
        configurable: true
    });
    TriggerUpsertPageService.prototype.update = function (id, formValues) {
        var payload = tslib_1.__assign({}, formValues, { id: id });
        return _super.prototype.update.call(this, id, payload);
    };
    TriggerUpsertPageService.prototype.parseCron = function (startProcessCronDetails) {
        var flatCron = null;
        try {
            if (startProcessCronDetails) {
                flatCron = JSON.parse(startProcessCronDetails);
            }
        }
        catch (e) {
            this._snack.error(this._translateService.instant('json_parse_fail') + " (#" + ClientErrorCodes.InvalidJSON + ")");
        }
        return new CustomCron(flatCron);
    };
    TriggerUpsertPageService.prototype._getExecutorRobots = function (triggerId) {
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetRobotIdsForSchedule(key=" + triggerId + ")")
            .pipe(map(function (_a) {
            var value = _a.value;
            return value.map(function (id) { return ({ id: id }); });
        }));
    };
    TriggerUpsertPageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TriggerUpsertPageService_Factory() { return new TriggerUpsertPageService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.AppStateFacade), i0.ɵɵinject(i3.SettingService), i0.ɵɵinject(i4.ProcessService), i0.ɵɵinject(i5.QueueDefinitionService), i0.ɵɵinject(i6.CalendarService), i0.ɵɵinject(i7.UiSnackBarService), i0.ɵɵinject(i8.HttpClient)); }, token: TriggerUpsertPageService, providedIn: "root" });
    return TriggerUpsertPageService;
}(ODataService));
export { TriggerUpsertPageService };
